import React from "react";
import { withTheme } from "styled-components";
import BaseIcon from "../../utils/BaseIcon";

var InfoSystemIcon = function InfoSystemIcon(props) {
  var icon = props.theme.colors.icon;
  var iconFill = props.fill || icon.fill;
  return /*#__PURE__*/React.createElement(BaseIcon, props, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: iconFill,
    fillRule: "nonzero",
    d: "M11.891 24.007c6.571 0 11.898-5.327 11.898-11.898S18.462.211 11.89.211-.007 5.538-.007 12.11 5.32 24.007 11.891 24.007zm0-1.5c-5.743 0-10.398-4.655-10.398-10.398 0-5.743 4.655-10.398 10.398-10.398 5.743 0 10.398 4.655 10.398 10.398 0 5.743-4.655 10.398-10.398 10.398zm0-14.866a1.122 1.122 0 100-2.243 1.122 1.122 0 000 2.243zM11.89 18.79a.75.75 0 00.751-.748l.014-7.677a.75.75 0 00-1.5-.003l-.014 7.677c0 .414.334.75.749.751z"
  })));
};

InfoSystemIcon.displayName = "InfoSystemIcon";
InfoSystemIcon.defaultProps = {
  size: 24
};
var ThemeWrappedIcon = withTheme(InfoSystemIcon);
ThemeWrappedIcon.displayName = "InfoSystemIcon";
ThemeWrappedIcon.iconName = "Info";
export default ThemeWrappedIcon;